import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#f8f9fa] flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl p-8 text-center border border-slate-100 shadow-sm">
          <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-8 h-8 text-slate-400" />
          </div>
          <h1 className="text-2xl font-bold text-[#0a2540] mb-2">
            Payment cancelled
          </h1>
          <p className="text-slate-600 mb-6">
            No worries - you can subscribe anytime when you're ready.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              onClick={() => navigate('/subscribe')}
              variant="outline"
              className="flex-1"
              data-testid="cancel-retry-btn"
            >
              Try Again
            </Button>
            <Button
              onClick={() => navigate('/library')}
              className="flex-1 bg-[#0a2540]"
              data-testid="cancel-library-btn"
            >
              Go to Library
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
